import * as React from 'react';
import  {
  withStyles,
  WithStyles,
  StyleRules
} from '@mui/styles';
import { Theme } from '@mui/styles';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import MomentUtils from '@date-io/moment';
import classNames from 'classnames';

// import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
// import MobileDatePicker from '@mui/lab/MobileDatePicker';
// import DatePicker from '@mui/lab/DatePicker';
// import AdapterMoment from '@mui/lab/AdapterMoment';
// import momentTimezone from "moment-timezone";
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';

const styles = (theme: Theme): StyleRules => ({
  datePicker: {
    marginTop: 0,
    width: '100%',
  }
});

interface Props extends TextFieldProps {
  value: any | undefined;
  autoOk?: boolean;
  keyboard?: boolean;
  clearable?: boolean;
  placeholder?: string;
  invalidLabel?: string;
  invalidDateMessage?: string;
  format?: string;
  className?: string;
  required?: boolean;
  minDate?: any;
  maxDate?: any;
  disablePast?: boolean;
  disableFuture?: boolean;
  animateYearScrolling?: boolean;
  openToYearSelection?: boolean;
  shouldDisableDate?: (day: any) => boolean;
  id?: any;
  style?: any;
  onKeydown?: (evt: any) => void;
  name?: string
  error?: any
  disabled?: boolean
  onChange?: any
  isKeyField?: boolean;
}

type State = {
  dateVal: string;
  newDateVal?: Date;
};

class DateField extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      dateVal: props.value || ''
    };
  }
  UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {

    this.setState({ dateVal: newProps.value || '' });
  }

  onDateBlur = (date: any) => {
    if (date && date.target && date.target.value) {
      const mu = new MomentUtils();
      const d = mu.parse(date.target.value, "MM/DD/YYYY");
      // If a user enteres a partial date and leaves the field, we should not try to parse it
      if (!d.isValid()){
        this.setState({ dateVal: '' });
      } else {
        // Be sure the date actually changed before calling this
        const dv = this.state.dateVal;
        if (!this.state.dateVal || d.format("MM/DD/YYYY") != (new Date(this.state.dateVal)).toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'})) {
          if (this.props.onChange && d.isValid && d.isValid()) {
            if (this.props.endOfDay) {
              this.props.onChange(d.utc().endOf('day') as any);
            } else {
              
              this.props.onChange(d.utc().startOf('day') as any);
            }
          } else {
            // We have a value, but cannot parse it, so default to today?
            const today = mu.moment(new Date());
            this.props.onChange(today);
            this.setState({ dateVal: today });
          }
        }
      }
    } else {
      this.setState({ dateVal: '' });
    }
  };

  onDateChange = (date: any) => {

    const self = this;
    
    if (date && date.isValid && date.isValid()) {

      if (this.props.onChange) {
      
    
      var newDate = new Date(Date.UTC(date.get('year'), date.get('month'), date.get('date'), 0, 0, 0, 0))

        this.props.onChange(newDate);
      }
    } else {
      const mu = new MomentUtils();
      this.setState(
        {
          dateVal: date
        },
        () => {
          if (self && self.props && self.props.onChange) {
            if (this.props.onChange) {
              self.props.onChange(date);
            }
          }
        }
      );
    }
  };

  handleDateChange = (date) => {
    // setSelectedDate(date);

  };

  onBlur = (event: any) => {
  };

  onKeydown = (e: any) => {
    if (this.props.onKeydown) {
      this.props.onKeydown(e);
    }
  };

  onError = (a: any, b:any, c:any) => {
      
  }

  renderInput = (props) => {
    var {classes, helperText, className} = this.props
    return (
      <TextField
        {...props}
        InputLabelProps={{
          shrink: true
        }}
        helperText={helperText}
        style={this.props.style}
        onBlur={this.onDateBlur}
        required={this.props.required}
        error={this.props.error}
        name={this.props.name || "date_picker"}
        className={classNames(classes.datePicker, className)}  
      />
    )
  }

  render() {
    // const { classes }: { classes:ClassNameMap } = this.props
    const {
      label,
      helperText,
      keyboard,
      invalidLabel,
      invalidDateMessage,
      format,
      clearable,
      placeholder,
      classes,
      autoOk,
      className
    } = this.props;
    const { dateVal } = this.state;
    const mu = new MomentUtils();

    var utcVal = null 
    if (dateVal) {
      utcVal = moment.utc(dateVal)
    }
  

    return (
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          onError={this.onError}
          InputAdornmentProps={{
            tabIndex: -1
          }}
          label={<span>{label}{this.props.isKeyField && !this.props.required && <i style={{ color: "#CD5C5C", marginLeft: 5 }} className="fa fa-key"></i>}</span>}
          inputProps={{
            name: this.props.name || "date_picker_input",
          }}
          placeholder={placeholder == undefined ? 'MM/DD/YYYY' : placeholder}
          renderInput={this.renderInput}
          clearable={true}
          mask="__/__/____"
          margin="normal"
          inputFormat={format == undefined ? 'MM/DD/YYYY' : format}
          value={utcVal != "" ? utcVal : null}
          onChange={this.onDateChange}
          minDate={
            this.props.minDate ? mu.moment(this.props.minDate) : null || null
          }
          maxDate={
            this.props.maxDate ? mu.moment(this.props.maxDate) : null || null
          }
          disabled={this.props.disabled}
        />
     </LocalizationProvider>
    );
  }
}

export default withStyles(styles)(DateField);